module.exports = __webpack_public_path__ + "img/silver.42629a80.svg";